/**
 * Which validity date a KYC document field captures, mirroring the backend
 * catalog (`compliance.document_types` / `fn_document_field_category`,
 * migration 0037). Identity documents carry a stamped EXPIRY; proof-of-address
 * and the MX SAT certificate are relative — they carry an ISSUE date and the
 * backend computes the expiry from the catalog window. Everything else (a
 * signature, an SSN/SIN card that never expires) captures nothing.
 *
 * Field keys are market-invariant (a passport is identity everywhere), so this
 * map matches the backend FIELD_CATEGORY. Keep the two in lockstep.
 */
export type DocumentValidityMode = 'expiry' | 'issued' | 'none';

const IDENTITY_FIELDS = new Set([
  'passport_doc', 'id_front', 'id_back', 'ine_front', 'ine_back',
  'id_document', 'drivers_license', 'national_id',
]);

// Relative-validity documents (expiry = issued_at + window). Address proofs in
// every market + the MX SAT constancia. SSN/SIN cards are fiscal-but-none, so
// they are intentionally NOT here.
const RELATIVE_FIELDS = new Set([
  'proof_of_address', 'address_proof', 'utility_bill',
  'rfc_document', 'tax_certificate',
]);

export function documentValidityMode(fieldKey: string): DocumentValidityMode {
  if (IDENTITY_FIELDS.has(fieldKey)) return 'expiry';
  if (RELATIVE_FIELDS.has(fieldKey)) return 'issued';
  return 'none';
}
